import React from 'react';
import { Avatar, AvatarGroup, Box, Tooltip, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useActiveUsersStore } from 'src/stores/ActiveUsersStore/ActiveUsersStore';
import { ACTIVE_USERS_MAX_DISPLAY } from 'src/constants/activeUsers';

const ActiveUsersAvatarGroup: React.FC = observer(() => {
  const { activeUsers } = useActiveUsersStore();

  if (!activeUsers.length) {
    return null;
  }

  const visibleCount = Math.min(activeUsers.length, ACTIVE_USERS_MAX_DISPLAY);

  return (
    <Box
      role="group"
      aria-label={`${visibleCount} workspace member${visibleCount === 1 ? '' : 's'} active now`}
      sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
    >
      <AvatarGroup
        max={ACTIVE_USERS_MAX_DISPLAY}
        sx={{ '& .MuiAvatar-root': { width: 28, height: 28, fontSize: 11 } }}
      >
        {activeUsers.map((user) => (
          <Tooltip
            key={user._id}
            title={`${user.displayName} · active now`}
            arrow
          >
            <Avatar
              src={user.profilePicture}
              alt={`${user.displayName} active now`}
            />
          </Tooltip>
        ))}
      </AvatarGroup>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: { xs: 'none', lg: 'block' }, whiteSpace: 'nowrap' }}
      >
        {visibleCount} active
      </Typography>
    </Box>
  );
});

export default ActiveUsersAvatarGroup;
